<template>
    <div class="w-100 mt-3">
        <div class="box">
            <div class="box-header">
                <h2>{{ client.name }} {{ client.product }}</h2>
                    <small v-for="(service,index) in client.services" class="d-inline">{{ service.name }}<span class="d-inline" v-if="index !== client.services.length - 1">, </span></small>
            </div>
            <div class="box-divider mx-0"></div>
            <div class="box-body" v-if="error === '' && !statsLoaded"><report-load></report-load></div>
            <div class="box-body" v-if="error === '' && statsLoaded">
                <table class="table">
                    <tr>
                        <td class="pl-0 border-top-0"></td>
                        <td class="text-right pr-0 border-top-0 pb-1"><small class="text-muted">Total / Month</small></td>
                    </tr>
                    <tr>
                        <td class="pl-0">Registered Customers</td>
                        <td class="text-right pr-0">{{ stats.product.enrolled.all }} / {{ stats.product.enrolled.month }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Eligible Customers</td>
                        <td class="text-right pr-0">{{ stats.product.eligible.current }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Active Customers</td>
                        <td class="text-right pr-0">{{ stats.product.active.current }} / {{ stats.product.active.month }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Helpline Calls <small>(Verified)</small></td>
                        <td class="text-right pr-0">{{ stats.services.calls.all.verified }} / {{ stats.services.calls.month.verified }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Helpline Enquiries</td>
                        <td class="text-right pr-0">{{ stats.services.enquiries.all.total }} / {{ stats.services.enquiries.month.total }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Health Check Submissions</td>
                        <td class="text-right pr-0">{{ stats.services.healthchecks.all }} / {{ stats.services.healthchecks.month }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Resource Downloads</td>
                        <td class="text-right pr-0">{{ stats.services.downloads.all }} / {{ stats.services.downloads.month }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Feedback Submissions</td>
                        <td class="text-right pr-0">{{ stats.services.pagefeedback.all }} / {{ stats.services.pagefeedback.month }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Comms Engagement <br><small>(Eligible Customers 90 Day Avg.)</small></td>
                        <td class="text-right pr-0">{{ stats.services.engagement_score }}%</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Scheme To Date Activated</td>
                        <td v-if="stats.product.enrolled.all > 0 && stats.product.active.scheme > 0" class="text-right pr-0">{{ stats.product.active.scheme }} ({{ Math.round((stats.product.active.scheme/stats.product.enrolled.all)*100) }}%)</td>
                        <td v-else class="text-right pr-0">{{ stats.product.active.scheme }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Avg. Customer Life</td>
                        <td class="text-right pr-0">{{ stats.product.stats.avg_life_days }} Days</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Avg. Customer Value (CLV)</td>
                        <td class="text-right pr-0">£{{ stats.product.stats.avg_customer_value }}</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Avg. Time To Activate</td>
                        <td class="text-right pr-0">{{ stats.product.stats.avg_days_to_activate }} Days</td>
                    </tr>
                    <tr>
                        <td class="pl-0">Non Invoiced <small>(exc current month)</small></td>
                        <td class="text-right pr-0">{{ nonInvoiced }}</td>
                    </tr>
                </table>
                <a v-bind:href="'/admin/reports/report/' + client.id + '/' + year + '/' + month" class="btn btn-outline-primary rounded-pill mb-3">View Report</a>
            </div>
            <div class="box-body" v-if="error !== ''">
                <p>{{ error }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ClientStats",
        props: ['client', 'month', 'year'],
        data() {
            return {
                error: "",
                stats: null,
                statsLoaded: false,
                nonInvoiced: '£0.00'
            }
        },
        mounted: function () {
            this.getReport();
        },
        methods: {
            getReport: function() {
                this.error = "";
                axios.post('/admin/dashboard/stats/' + this.client.id, {
                    month: this.month,
                    year: this.year,
                    liveBase: true
                })
                    .then(response => {
                            this.stats = response.data;

                            if(this.stats.product.enrolled.all === 0) {
                                this.error = "No customer data to display.";
                                this.statsLoaded = true;
                                return;
                            }

                            this.statsLoaded = true;
                            if(!this.client.registration_enabled) {
                                if(this.stats.product.revenue || this.stats.product.revenue === 0) {
                                    axios.post('/admin/dashboard/non-invoiced/' + this.client.id, {
                                        revenue: this.stats.product.revenue
                                    }).then(response => {
                                        this.nonInvoiced = '£' + response.data;
                                    });
                                } else {
                                    this.nonInvoiced = "Calculating...";
                                    setTimeout(() => {
                                        this.getReport();
                                    }, 10000);
                                }
                            } else {
                                this.nonInvoiced = 'N/A';
                            }
                    }).catch(error => {
                    if(error.response.status === 404){
                        this.error = "Data not found.";
                    }
                    if(error.response.status === 500){
                        this.error = "We encountered a problem whilst fetching the report.";
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
